import api from '@/services/api'
import { ls } from '@/services/storage'
import { sumMoney } from '@/utils/helpers'

const LS_TTL_SECONDS_PLAYER = 60

export default {
  namespaced: true,
  state: {
    player: ls.get('player-v2')
  },
  getters: {
    cappingFreeUsed: state => competitionId => {
      if (state.player) {
        return state.player.free.includes(competitionId)
      }
      return false
    },
    cappingPaidLeft (state, getters, rootState) {
      if (state.player) {
        return sumMoney(rootState.app.settings.dailyCapping, -state.player.paid)
      }
      return rootState.app.settings.dailyCapping
    }
  },
  mutations: {
    setPlayer (state, data) {
      state.player = data
      ls.set('player-v2', data, LS_TTL_SECONDS_PLAYER)
    },
    updatePlayer (state, data) {
      state.player = data
      ls.update('player-v2', data)
    },
    deletePlayer (state) {
      state.player = null
      ls.del('player-v2')
    },
    addCappingFree (state, competitionId) {
      state.player.free.push(competitionId)
      ls.update('player-v2', state.player)
    },
    removeCappingFree (state, competitionId) {
      var index = state.player.free.indexOf(competitionId)
      if (index !== -1) {
        state.player.free.splice(index, 1)
        ls.update('player-v2', state.player)
      }
    },
    addCappingPaid (state, cost) {
      state.player.paid = sumMoney(state.player.paid, cost)
      ls.update('player-v2', state.player)
    },
    removeCappingPaid (state, cost) {
      state.player.paid = sumMoney(state.player.paid, -cost)
      ls.update('player-v2', state.player)
    }
  },
  actions: {
    async removePaymentMethod ({ dispatch }, { token }) {
      await api.players.removePaymentMethod({ token })
      await dispatch('loadAccount', { ignoreCache: true })
    },
    async loadAccount ({ commit }, { ignoreCache = false } = {}) {
      const cached = ls.cached('player-v2')
      if (!ignoreCache && cached) {
        return cached
      }
      const data = await api.players.loadAccount()
      commit('setPlayer', data)
    }
  }
}
